import type { SupportedVideoEmbedTypes, EmbedMeta } from './types'

export const embedMappings: Partial<Record<SupportedVideoEmbedTypes, EmbedMeta>> = {
    'daily-motion': {
        buildSource: ({ videoId }) => ({ src: `https://www.dailymotion.com/embed/video/${videoId}` }),
        iframeProps: {
            height: 450,
        },
    },
    facebook: {
        buildSource: ({ videoId }) => ({
            srcDoc: `
            <html>
                <head>
                    <script async defer crossorigin='anonymous' src='https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v22.0'></script>
                </head>
                <body>
                    <div id='fb-root'></div>
                    <div class='fb-video w-full' data-href='https://www.facebook.com/facebook/videos/${videoId}/' data-allowfullscreen='true'></div>
                </body>
            </html>`,
        }),
        iframeProps: {
            height: 359,
        },
    },
    tiktok: {
        buildSource: ({ videoId }) => ({
            srcDoc: `
        <html lang="en">
            <head>
                <meta http-equiv="Content-Type" content="text/html; charset=utf-8">
                <meta name="ROBOTS" content="NOINDEX, NOFOLLOW">
                <base target="_blank">
                <style>
                    * {
                        box-sizing: border-box;
                    }
                    body, html {
                        margin: 0;
                        padding: 0;
                        min-height: 10px;
                    }
                    body {
                        text-rendering: optimizeLegibility;
                        overflow: hidden;
                        position: relative;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }
                    iframe {
                        max-width: 100%;
                        min-height: 100%;
                        height: 758px;
                        display: block;
                        visibility: unset;
                        max-height: 758px;
                        width: 330px;
                    }
                    iframe:after, object:after {
                        clear:both;
                    }
                </style>
            </head>
            <body>
                <iframe name="__tt_embed__v52429505603859470" sandbox="allow-popups allow-popups-to-escape-sandbox allow-scripts allow-top-navigation allow-same-origin" scrolling='no' src="https://www.tiktok.com/embed/v2/${videoId}?lang=en-US&amp;embedFrom=oembed"></iframe>
            </body>
        </html>
            `,
        }),
        iframeProps: {
            className: 'w-full fit-content rounded-2xl p-4 my-4 bg-gray-200',
            height: 790,
        },
    },
    youtube: {
        buildSource: ({ videoId }) => ({ src: `https://www.youtube.com/embed/${videoId}?wmode=transparent&rel=0&autohide=1&enablejsapi=1&showinfo=0&start=0` }),
        iframeProps: {
            height: 450,
        },
    },
    'youtube-playlist': {
        buildSource: ({ videoId, secondaryId }) => ({
            src: `https://www.youtube.com/embed/${videoId}?wmode=transparent&rel=0&autohide=1&enablejsapi=1&showinfo=1&list=${secondaryId}&start=0`,
        }),
        iframeProps: {
            height: 450,
        },
    },
    reddit: {
        buildSource: ({ videoId, secondaryId }) => ({
            src: `https://embed.reddit.com/r/${secondaryId}/comments/${videoId}/?embed=true&ref_source=embed&ref=share&utm_medium=widgets&utm_source=embedv2&utm_term=23&utm_name=post_embed`,
        }),
        iframeProps: {
            height: 740,
        },
    },
    imgur: {
        buildSource: ({ videoId }) => ({ src: `https://imgur.com/${videoId}/embed?w=540` }),
        iframeProps: {
            height: 423,
            width: 540,
        },
    },
    vimeo: {
        buildSource: ({ videoId }) => ({ src: `https://player.vimeo.com/video/${videoId}` }),
        iframeProps: {
            height: 500,
        },
    },
}
